// extracted by mini-css-extract-plugin
export const slider_animation = "animation-module--slider_animation--1E6Au";
export const slidein = "animation-module--slidein--T8fWZ";